import React from "react";

const Heading = () => {
  return (
    <div className="heading">
      <span id="child1">Name</span>
      <span id="child2">Mobile Number</span>
      <span id="child3">Email</span>
    </div>
  );
};

export default Heading;
